<template>
    <div class="form-group">
        <label v-bind:for="id">{{ label }}</label>
        <input v-if="type == 'cpf'" type="text" v-mask="['###.###.###-##']" v-bind:class="classe" v-bind:value="value" v-bind:name="name" v-bind:placeholder="placeholder" v-bind:id="id" v-bind:required="required" v-bind:disabled="disabled" v-bind:readonly="readonly"/>
        <input v-else-if="type == 'cnpj'" type="text" v-mask="['##.###.###/####-##']" v-bind:class="classe" v-bind:value="value" v-bind:name="name" v-bind:placeholder="placeholder" v-bind:id="id" v-bind:required="required" v-bind:disabled="disabled" v-bind:readonly="readonly"/>
        <input v-else type="text" v-mask="['###.###.###-##', '##.###.###/####-##']" v-bind:class="classe" v-bind:value="value" v-bind:name="name" v-bind:placeholder="placeholder" v-bind:id="id" v-bind:required="required" v-bind:disabled="disabled" v-bind:readonly="readonly"/>
    </div>
</template>

<script>

    import { mask } from 'vue-the-mask'

    export default {
        name: 'input-cpfcnpj',
        directives: { mask },
        props: {
            options: {
                type: Object,
                default: () => ({}),
        }
    },

    data() {

        return {
            name: (this.options.name) ? this.options.name : 'cpfcnpj',
            id: (this.options.id) ? this.options.id : 'cpfcnpj',
            value: (this.options.value) ? this.options.value : '',
            placeholder: (this.options.placeholder) ? this.options.placeholder : '00.000.000/0000-00',
            label: (this.options.label) ? this.options.label : 'CPF/CNPJ:',
            classe: (this.options.class) ? 'form-control ' + this.options.class : 'form-control',
            required: (this.options.required) ? this.options.required : false,
            disabled: (this.options.disabled) ? this.options.disabled : false,
            type: (this.options.type)? this.options.type : null,
            readonly: (this.options.readonly) ? this.options.readonly : false,
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CpfCnpj.vue